import { useState, useEffect } from "react";

export default function PaymentAddonOngoingComponent() {
  const [animated, setAnimated] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setAnimated(true);
    }, 50);

    // Ensure the overlay scrolls to top when modal opens
    if (typeof window !== "undefined") {
      window.scrollTo(0, 0);
    }
  }, []);

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/50 backdrop-blur-sm animate-fade-in z-50">
      <div
        className={`relative bg-gradient-to-b from-slate-950 to-fuchsia-950/80 border border-red-900/30 rounded-xl p-8 w-full max-w-md mx-4 transform transition-all duration-700 ${
          animated ? "scale-100 opacity-100 translate-y-0" : "scale-95 opacity-0 translate-y-4"
        }`}
      >
        <div className="flex flex-col items-center">
          {/* Loading Spinner */}
          <div className="w-16 h-16 mb-6 relative">
            <div className="absolute inset-0 border-4 border-red-500/20 rounded-full"></div>
            <div className="absolute inset-0 border-4 border-red-500 rounded-full animate-spin border-t-transparent"></div>
          </div>

          {/* Loading Text */}
          <h3 className="text-2xl font-bold text-pink-200 mb-4 text-center">Processing Your Addon Purchase</h3>

          <div className="bg-slate-900/50 rounded-lg p-6 mb-6 border border-pink-900/30 w-full">
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <div className="w-2 h-2 bg-pink-500 rounded-full"></div>
                <p className="text-gray-300">Verifying payment details...</p>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-2 h-2 bg-pink-500 rounded-full"></div>
                <p className="text-gray-300">Processing your addon purchase...</p>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-2 h-2 bg-pink-500 rounded-full"></div>
                <p className="text-gray-300">Adding credits to your account...</p>
              </div>
            </div>
          </div>

          <p className="text-gray-400 text-sm text-center">Please wait while we process your request...</p>
        </div>
      </div>
    </div>
  );
}
